import { Component, input, output, computed } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-rating',
  standalone: true,
  imports: [IonicModule, FormsModule],
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss'],
})
export class RatingComponent {
  // Input-signaler
  rating = input<number>(0);
  width = input<string>('200px');
  readonly = input<boolean>(false); // Ny input for skrivebeskyttelse

  // Output-event
  ratingChange = output<number>();

  private glassAspectRatio = 0.8;

  containerStyle = computed(() => ({
    'width': this.width(),
    'height': `calc(${this.width()} / 5 / ${this.glassAspectRatio} - 10px)`,
    'cursor': this.readonly() ? 'default' : 'pointer'
  }));

  fillPercentage = computed(() => (this.rating() / 5) * 100);

  readonly glasses = [1, 2, 3, 4, 5];

  getGlassFillPercentage(index: number): number {
    const rating = this.rating();
    const glassNumber = index + 1;

    if (rating >= glassNumber) {
      return 100; // Helt fylt
    } else if (rating > glassNumber - 1) {
      // Delvis fylt - beregn prosent av dette glasset
      return (rating - (glassNumber - 1)) * 100;
    }
    return 0; // Tomt
  }

  onSliderInput(event: any) {
    if (!this.readonly()) {
      const val = parseFloat(event.detail.value);
      this.ratingChange.emit(val);
    }
  }
}